import { Component } from '@angular/core';
import { SideMenuGroup, SideMenuComponent } from '@rbb/ng-web-template-lib';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-admin-home',
  templateUrl: './admin-home.component.html',
  styleUrls: ['./admin-home.component.css'],
  imports: [RouterOutlet, SideMenuComponent]
})
export class AdminHomeComponent {
  sideMenuGroups: SideMenuGroup[] = [
    {
      name: 'Admin',
      entries: [
        {
          name: 'Explorer',
          icon: 'fa-solid fa-folder-tree',
          routerLink: '/admin/explorer'
        },
        {
          name: 'Formulare',
          icon: 'fa-solid fa-book',
          routerLink: '/admin/forms'
        },
        {
          name: 'Einstellungen',
          icon: 'fa-solid fa-tools',
          routerLink: '/admin/settings'
        }
      ]
    }
  ];
}
